import { useCallback, useEffect, useState } from 'react';

import { DESKTOP, MOBILE } from '@/constants';
import { breakpoints } from '@/styles/breakpoints';

const getInitValue = () => {
  if (typeof window !== 'undefined') {
    return window?.innerWidth ?? 0;
  } else {
    return 0;
  }
};

const useDeviceDetect = () => {
  const [windowWidth, setWindowWidth] = useState(getInitValue());

  const handleWindowSizeChange = useCallback(() => {
    const { innerWidth } = window;
    if (windowWidth !== innerWidth) {
      setWindowWidth(innerWidth);
    }
  }, [windowWidth]);

  useEffect(() => {
    handleWindowSizeChange();
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, [handleWindowSizeChange]);

  const isDesktop = windowWidth >= breakpoints.desktop;
  const isMobile = windowWidth < breakpoints.desktop;

  const viewport = isDesktop ? DESKTOP : MOBILE;

  return { isDesktop, isMobile, width: windowWidth, viewport };
};

export default useDeviceDetect;
